import { render, staticRenderFns } from "./DefaultNot.vue?vue&type=template&id=7c30abfe&scoped=true"
import script from "./DefaultNot.vue?vue&type=script&lang=js"
export * from "./DefaultNot.vue?vue&type=script&lang=js"
import style0 from "./DefaultNot.vue?vue&type=style&index=0&id=7c30abfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c30abfe",
  null
  
)

export default component.exports